import { openPopup } from "./helpers/openPopup.js";

export async function error(scope, ctx, err) {
    console.error("Game error:", err);

    const { scenes, hud } = ctx;

    hud.setPopupState();

    const popup = await openPopup(scope, scenes, "ErrorMessagePopupScene", {
        title: "ERROR",
        message: err?.message ?? "INTERNAL ERROR",
        showCloseButton: true,
        showReloadButton: true,
    });

    const result = await Promise.race([
        scope.wait(popup.onPressClose).then(() => "close"),
        scope.wait(popup.onPressReload).then(() => "reload"),
    ]);

    if (result === "reload") {
        window.location.reload();
    }
}
